module.exports = __webpack_public_path__ + "img/selected-marker-green.2c229dfd.svg";